// Teal family — dark shade → base → pale tint (hue ~174).
const TEAL_RAMP = [
  '#14403C', // teal deepest
  '#1D544F', // teal deep
  '#266861', // teal darker
  '#2F7C74', // teal dark
  '#3A9C95', // brand teal (base)
  '#47A69E', // teal
  '#55B0A8', // teal
  '#5CC4BB', // brand teal light (base)
  '#74CEC6', // teal light
  '#8BD8D1', // teal lighter
  '#9BDDD7', // brand teal pale (base)
  '#B7E7E2', // teal pale
  '#D3F1EE', // teal palest
];

// Slate/gray family — dark shade → base → light tint (hue ~215).
const SLATE_RAMP = [
  '#1B212B', // slate deepest
  '#252E3B', // slate deep
  '#2F3949', // slate darker
  '#374151', // brand slate (base)
  '#45526A', // slate
  '#556077', // slate
  '#667080', // slate gray
  '#7C8593', // cool gray
  '#8893A0', // cool gray
  '#9BA4AF', // gray
  '#B0B8C1', // gray light
  '#C8CDD4', // light gray
  '#DEE2E6', // gray palest
];

const interleave = (a, b) => {
  const out = [];
  const max = Math.max(a.length, b.length);
  for (let i = 0; i < max; i += 1) {
    if (i < a.length) out.push(a[i]);
    if (i < b.length) out.push(b[i]);
  }
  return out;
};

export const STACK_BAR_COLORS = interleave(
  ['#3A9C95', '#5CC4BB', '#9BDDD7', ...TEAL_RAMP.filter(c => !['#3A9C95', '#5CC4BB', '#9BDDD7'].includes(c))],
  ['#374151', '#8893A0', '#C8CDD4', ...SLATE_RAMP.filter(c => !['#374151', '#8893A0', '#C8CDD4'].includes(c))]
);

export const pickSegmentColors = count => {
  if (!count || count <= 0) return [];

  const palette = STACK_BAR_COLORS;

  if (count >= palette.length) {
    return Array.from({ length: count }, (_, i) => palette[i % palette.length]);
  }

  const step = palette.length / count;
  return Array.from({ length: count }, (_, i) => palette[Math.floor(i * step)]);
};

export const withSegmentColors = (segments = []) => {
  const colors = pickSegmentColors(segments.length);
  return segments.map((segment, i) => ({
    ...segment,
    color: segment.color || colors[i],
  }));
};
